module.exports = __webpack_public_path__ + "img/SMS80101-L-min.7935ebd3.png";